// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

type OwnProps = WidgetProps;

export interface ProductDetailsAddToCartSectionStyles {
    wrapper?: InjectableCss;
    qtyWrapper?: InjectableCss;
    addToCartWrapper?: InjectableCss;
}

export const productDetailsAddToCartSectionStyles: ProductDetailsAddToCartSectionStyles = {
    wrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
        `,
    },
    addToCartWrapper: {
        css: css`
            width: 100%;
        `,
    },
};

const styles = productDetailsAddToCartSectionStyles;

const ProductDetailsAddToCartSection: FC<OwnProps> = () => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.qtyWrapper}>
                {createWidgetElement("ProductDetails/ProductDetailsQuantityOrdered", {
                    fields: {},
                })}
            </StyledWrapper>
            <StyledWrapper {...styles.addToCartWrapper}>
                {createWidgetElement("ProductDetails/ProductDetailsAddToCartButton", {
                    fields: {},
                })}
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ProductDetailsAddToCartSection,
    definition: {
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        displayName: "Product Details Add to Cart Section",
    },
};

export default widgetModule;
